module.exports = __webpack_public_path__ + "img/clean.4f9f17ca.svg";